var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portfolio-inestment-card"},[_c('CardButtons',{attrs:{"title":_vm.title,"description":_vm.description,"paragraph":_vm.paragraph,"action-button-list":_vm.button},on:{"onClick":_vm.open}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }